var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLock = function SvgIcLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    y: 6,
    fill: "#4A5A75",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 3,
    y: 1,
    stroke: "#4A5A75",
    strokeWidth: 2,
    rx: 3
  }))));
};
export default SvgIcLock;